import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Centro_Title } from '../../../../../utils/ES/Modals/VideoModals';

const ModalVideoCentro = () => {
  return (
    <>
      <ModalVideo
        id="centro-videoclips"
        dataText={Centro_Title}
        videoSrc="https://player.vimeo.com/video/388577609?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_CENTRO"
      />
    </>
  );
};

export default ModalVideoCentro;
